import { type ThemeOptions, ThemeProvider, createTheme } from '@mui/material';

const defaultThemeOptions: ThemeOptions = Object.freeze({
  typography: {
    fontFamily: ['"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', '"Noto Sans"'].join(','),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1600,
    },
  },
  palette: {
    primary: {
      main: '#4fb348',
    },
    secondary: {
      main: '#484fb3',
    },
  },
});

export const PageUIBuilderTheme = (props: { children: React.ReactNode }) => {
  const theme = createTheme({
    ...defaultThemeOptions,
    // we want a smaller size for the content here -> since there is a lot of information being displayed
    typography: {
      ...defaultThemeOptions.typography,
      htmlFontSize: 18,
      button: {
        lineHeight: 1.5,
      },
    },
    components: {
      MuiTextField: {
        defaultProps: {
          variant: 'outlined',
          size: 'small',
        },
      },
    },
  });
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

type ThemeWrapperProps = {
  children: React.ReactNode;
};

const ThemeWrapper = (props: ThemeWrapperProps) => {
  const customTheme = createTheme({
    ...defaultThemeOptions,
    typography: {
      fontFamily: [
        ...(window?.znRuntime?.theme?.fontStyle ? [window?.znRuntime?.theme?.fontStyle] : []),
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        '"Noto Sans"',
      ].join(','),
    },
  });

  return <ThemeProvider theme={customTheme}>{props.children}</ThemeProvider>;
};

export default ThemeWrapper;
